module.exports = __webpack_public_path__ + "static/media/4.98a8047a.jpg";